
import {BeanQuestionXAnswers} from './BeanQuestionXAnswers'

export class BeanQuestion {
    constructor(
        public pergIdCdPergunta: number,
        public cateIdCdCategoria: number,
        public pergDsPergunta: string,
        public pergDsObservacao: string,
        public pergDhInativo: string,
        public grcaIdCdGrupoCategoria: number,
        public questionAnswers: BeanQuestionXAnswers[],
        public permNrSequencia: number,
        public isCommented = false,
        public isContested = false,
        public pergNrOrdem   : string,
        public pergInExtra   : string,
        public pergInRespostasemlista   : string,
        
        
    ){}
}
